import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/zh-cn/services/clinical-solutions/ivd-clinical-performance-studies")({
  head: () => buildRouteHead("/zh-cn/services/clinical-solutions/ivd-clinical-performance-studies", {
      title: "IVD 临床性能研究 — 临床解决方案 | QbD Group",
      description: "按照 IVDR 证据要求设计并执行 IVD 临床性能研究，涵盖方案设计、研究中心选择、数据分析与报告。",
    }),
  component: ClinicalIndustry,
});

